const DRAFT_VERSION = 1;

export function hiringRequestDraftKey(token) {
    return `hr:hiring-request:draft:v${DRAFT_VERSION}:${encodeURIComponent(String(token || ""))}`;
}

export function readHiringRequestDraft(key) {
    if (!key || typeof window === "undefined") return null;
    try {
        const parsed = JSON.parse(window.localStorage.getItem(key));
        if (!parsed || parsed.version !== DRAFT_VERSION || typeof parsed.form !== "object") return null;
        if (parsed.expiresAt && new Date(parsed.expiresAt).getTime() <= Date.now()) {
            window.localStorage.removeItem(key);
            return null;
        }
        return parsed;
    } catch (_) {
        window.localStorage.removeItem(key);
        return null;
    }
}

export function writeHiringRequestDraft(key, { form, step, expiresAt }) {
    if (!key || typeof window === "undefined") return;
    try {
        window.localStorage.setItem(key, JSON.stringify({
            version: DRAFT_VERSION,
            form,
            step,
            expiresAt: expiresAt || null,
            savedAt: new Date().toISOString(),
        }));
    } catch (_) {
        // localStorage can be disabled or full; form entry must keep working.
    }
}

export function clearHiringRequestDraft(key) {
    if (!key || typeof window === "undefined") return;
    try {
        window.localStorage.removeItem(key);
    } catch (_) {
        // Ignore unavailable localStorage after a successful submission.
    }
}
